import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import toast from "react-hot-toast";
import { renderFieldText, renderSelect, classNames } from "@basecomponent";
import { confirmAlert } from "react-confirm-alert";
import LocaleStrings from "@language";
import { itemCount } from "@constant";
import Pagination from "@pagination";
import {
  fetchSpecification,
  addVehicle,
  validateNumberPlate,
  activateDeactivate,
  deleteNumberplate,
  setNumberplate,
  updateVehicle,
  validateNumberPlateEdit,
} from "@numberplateaction";
import { fetchBagdeList } from "@badgesaction";
import _ from "lodash";

const Badge = (props) => {
  var {
    handleSubmit,
    pristine,
    invalid,
    submitting,
    session,
    specList,
    eventData,
    badgeList,
    toEdit,
    initialValues,
    localeLanguage,
  } = props;
  var [loading, setLoading] = useState(false);
  var [pageNumber, setPageNumber] = useState(1);
  const headerRef = useRef();

  useEffect(() => {
    // console.log("eventData", eventData);
    if (eventData) {
      props.fetchBagdeList(session, eventData.useridfk, 0, (res) => {});
      props.fetchSpecification(session, eventData.useridfk, (res) => {});
    }
    props.setNumberplate({});
  }, [localeLanguage, eventData]);

  const onSubmitForm = (values) => {
    setLoading(true);
    values.hruserid = session.userid;
    values.isbadge = 1;
    values.numberplate =
      values.type +
      "." +
      values.numberplate.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    var match = _.filter(specList?.data, (ob) => {
      return ob.costid == values.programid;
    });
    let locationid = null;
    if (match.length > 0) {
      locationid = match[0].locationidfk;
    }
    // values.programid = values.programid == "null" ? null : values.programid;
    if (toEdit) {
      let pageNo = pageNumber;
      let pageDataLength = badgeList?.data?.length;
      if (pageDataLength == 1) {
        pageNo = pageNo - 1;
      }
      //console.log("values", values);
      //debugger;
      props.updateVehicle(
        session,
        values,
        eventData.useridfk,
        locationid,
        (feedback) => {
          setLoading(false);
          if (feedback.success === 1) {
            props.setNumberplate({});
            props.fetchBagdeList(
              session,
              eventData.useridfk,
              pageNo,
              (res) => {}
            );
            setPageNumber(pageNo);
            toast.success(LocaleStrings.badge_updated);
            props.reset();
          } else {
            props.reset();
            toast.error(LocaleStrings.common_fail_message);
          }
        }
      );
    } else {
      values.programid = values.programid == "null" ? null : values.programid;
      props.validateNumberPlate(session, values.numberplate, (response) => {
        if (response.success === 2) {
          setLoading(false);
          toast.error(LocaleStrings.badge_already_exist);
        } else if (response.success === 1) {
          props.addVehicle(
            session,
            values,
            eventData.useridfk,
            locationid,
            (feedback) => {
              //console.log("feedback", feedback);
              setLoading(false);
              if (feedback.success === 1) {
                props.fetchBagdeList(
                  props.session,
                  eventData.useridfk,
                  0,
                  (res) => {}
                );
                toast.success(LocaleStrings.badge_added);
                props.reset();
              } else {
                props.reset();
                toast.error(LocaleStrings.common_fail_message);
              }
            }
          );
        } else {
          setLoading(false);
          toast.error(LocaleStrings.common_fail_message);
        }
      });
    }
  };

  const renderItems = () => {
    return badgeList?.data?.map((item, index) => {
      return (
        <tr className="bg-white">
          <td className="px-6 py-4 whitespace-nowrap">
            <div className="flex items-center">
              <div className="text-sm font-medium text-primary">
                {item.numberplate}
              </div>
            </div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            <div className="flex items-center">
              <div className="text-sm font-medium text-primary">
                {item.reference}
              </div>
            </div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            <div className="flex items-center">
              <div className="text-sm font-medium text-primary">
                {item.device_usage_cost_by_company_vehicle_program &&
                item.device_usage_cost_by_company_vehicle_program.length > 0
                  ? item.device_usage_cost_by_company_vehicle_program[0]
                      .specification
                  : ""}
              </div>
            </div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                <input
                  type="checkbox"
                  name="toggle"
                  id={item.vehicleid}
                  className="checkclass"
                  checked={item.isactive ? true : false}
                  onClick={() => activateDeactivate(item)}
                  style={{ outline: "none" }}
                />
                <label
                  for={item.vehicleid}
                  className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer appearance-none focus:outline-none"
                ></label>
              </div>
            </div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap">
            <div className="flex items-center justify-start lg:justify-between">
              <span
                className="text-theme cursor-pointer hover:text-themeDark pr-3 lg;pr-0"
                onClick={(e) => editItem(e, item)}
              >
                {LocaleStrings.button_edit}
              </span>
              <span
                className="text-theme cursor-pointer hover:text-themeDark"
                onClick={(e) => deleteItem(e, item.vehicleid)}
              >
                {LocaleStrings.button_delete}
              </span>
            </div>
          </td>
        </tr>
      );
    });
  };

  const activateDeactivate = (item) => {
    let pageNo = pageNumber;
    let pageDataLength = badgeList?.data?.length;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }
    let values = {};
    values.isactive = item.isactive ? 0 : 1;
    props.activateDeactivate(session, values, item.vehicleid, (feedback) => {
      if (feedback.success === 1) {
        props.fetchBagdeList(session, eventData.useridfk, pageNo, (res) => {});
        setPageNumber(pageNo);
        toast.success(
          item.isactive
            ? LocaleStrings.badge_deactivate
            : LocaleStrings.badge_activate
        );
      } else {
        toast.error(LocaleStrings.common_fail_message);
      }
    });
  };

  const editItem = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    props.setNumberplate({});
    let pageNo = pageNumber;
    let pageDataLength = badgeList?.data?.length;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    setTimeout(() => {
      props.setNumberplate(item);
      // headerRef.current.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start",
      // });
    }, 500);
  };

  const deleteItem = (e, vehicleid) => {
    e.preventDefault();
    e.stopPropagation();

    let pageNo = pageNumber;
    let pageDataLength = badgeList?.data?.length;
    if (pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    confirmAlert({
      title: LocaleStrings.badge_delete_title,
      message: LocaleStrings.badge_delete_text,
      buttons: [
        {
          label: LocaleStrings.button_yes,
          onClick: () => {
            props.deleteNumberplate(session, vehicleid, (response) => {
              if (response.success == 1) {
                props.fetchBagdeList(
                  session,
                  eventData.useridfk,
                  pageNo,
                  (res) => {}
                );
                setPageNumber(pageNo);
                toast.success(LocaleStrings.badge_delete_success);
              } else {
                toast.error(LocaleStrings.common_fail_message);
              }
            });
          },
        },
        {
          label: LocaleStrings.button_no,
          onClick: () => {},
        },
      ],
    });
  };

  const paginationCallback = (pageNum) => {
    props.fetchBagdeList(session, eventData.useridfk, pageNum, (res) => {});
    setPageNumber(pageNum);
  };

  let specoptions = [];
  specoptions.push({
    value: "",
    text: LocaleStrings.numberplate_select_fixed_program,
  });
  if (specList?.data?.length > 0) {
    _.map(specList.data, (item, index) => {
      specoptions.push({ value: item.costid, text: item.specification });
    });
  }

  specoptions.push({ value: "null", text: LocaleStrings.clear_fixed_program });
  var types = [
    //{ value: "", text: "Select" },
    // { value: "BE", text: "BE" },
    // { value: "NL", text: "NL" },
    { value: "KY", text: "KY" },
  ];

  //console.log("specList?.data", specList?.data);
  return (
    <>
      <div ref={headerRef} className="p-8 space-y-10">
        <div className="bg-white rounded-lg w-full p-6 shadow-md">
          <div className="border-b pb-2 text-base font-bold">
            {toEdit
              ? LocaleStrings.edit_badge_text
              : LocaleStrings.add_badge_text}
          </div>
          <form
            onSubmit={handleSubmit(onSubmitForm)}
            className="space-y-6 pt-6"
          >
            <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
              <Field
                name="type"
                label=""
                component={renderSelect}
                mandatory="true"
                opts={types}
              />
              <Field
                name="numberplate"
                label=""
                placeholder={LocaleStrings.enter_badge_number}
                type="text"
                component={renderFieldText}
                mandatory="true"
                maxlength={100}
              />
              <Field
                name="reference"
                label=""
                placeholder={LocaleStrings.reference}
                type="text"
                component={renderFieldText}
                mandatory="true"
                maxlength={100}
              />

              <Field
                name="programid"
                label=""
                // placeholder={
                //   toEdit
                //     ? initialValues.programid
                //       ? LocaleStrings.clear_fixed_program
                //       : LocaleStrings.numberplate_select_fixed_program
                //     : LocaleStrings.numberplate_select_fixed_program
                // }
                component={renderSelect}
                mandatory="true"
                opts={specoptions}
              />

              <div className="flex items-center justify-end">
                <button
                  type="submit"
                  disabled={pristine || invalid || submitting || loading}
                  className="bg-managebutton rounded py-2 px-5 w-full flex items-center justify-center"
                >
                  {loading ? (
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  ) : (
                    ""
                  )}
                  {toEdit
                    ? LocaleStrings.badge_update
                    : LocaleStrings.badge_add}
                </button>
              </div>
            </div>
          </form>
        </div>

        <div className="bg-white rounded-lg w-full p-6 text-base shadow-md">
          <div className="border-b pb-2">{LocaleStrings.my_badges}</div>
          <div className="overflow-x-auto">
            <div className="align-middle inline-block min-w-full">
              <div className="overflow-hidden ">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {LocaleStrings.badge_header}
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {LocaleStrings.reference_header}
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {LocaleStrings.fixed_washing_program_header}
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        {LocaleStrings.numberplate_deactivate_header}
                      </th>
                      <th scope="col" className="relative px-6 py-3">
                        <span className="sr-only">Actions</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>{renderItems()}</tbody>
                </table>
              </div>
            </div>
          </div>
          {/* Pagination */}
          {badgeList?.count > itemCount ? (
            <Pagination
              activePage={pageNumber}
              itemsCountPerPage={itemCount}
              totalItemsCount={badgeList?.count}
              onChange={paginationCallback}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
};

const validate = (values) => {
  var errors = {};
  //let re = /^[A-Za-z0-9]*$/;
  const inputString = "YourInputStringHere";
  const regexPattern = /^(?!.*[Kk][Yy])[a-zA-Z0-9]*$/;
  var type = values["type"];
  var numberplate = values["numberplate"];
  if (!type || type.trim() === "") {
    errors["type"] = LocaleStrings.required;
  }
  if (!numberplate || numberplate.trim() === "") {
    errors["numberplate"] = LocaleStrings.required;
  }else if(! regexPattern.test(numberplate)) {
    errors["numberplate"] = LocaleStrings.invalid;
  }
  return errors;
};

const mapStateToProps = (state) => {
  var init = {};
  init.type = "KY";
  var toEdit = !_.isEmpty(state?.editNumberplate);
  //console.log("editNumberplate", state.editNumberplate);
  if (toEdit) {
    let array = [];
    if (state?.editNumberplate?.numberplate) {
      array = state?.editNumberplate?.numberplate.split(".");
    }
    init.type = array.length > 0 ? array[0] : "KY";
    init.numberplate = array.length > 0 ? array[1] : "";
    init.programid =
      state?.editNumberplate?.device_usage_cost_by_company_vehicle_program[0]?.costid;
    init.reference = state?.editNumberplate?.reference;
    init.vehicleid = state?.editNumberplate?.vehicleid;
  }

  return {
    session: state.session,
    initialValues: init,
    specList: state.specList,
    eventData: state.eventData,
    badgeList: state.badgeList,
    editNumberplate: state.editNumberplate,
    toEdit,
    localeLanguage: state.localeLanguage,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchBagdeList,
      fetchSpecification,
      addVehicle,
      validateNumberPlate,
      activateDeactivate,
      deleteNumberplate,
      setNumberplate,
      updateVehicle,
      validateNumberPlateEdit,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "BadgeForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Badge)
);
